<script setup lang="ts">
import type { SocialLink } from "../../../typings/database.d";

type Props = { links: SocialLink[] };

const props = defineProps<Props>();
const links = props.links.filter((link) => link.visible);
</script>
<template>
  <address class="h-full flex flex-col pt-8 not-italic">
    <ul class="flex lg:flex-col lg:gap-y-1 gap-x-4 text-right">
      <li v-for="icon in links" :key="icon.name">
        <a
          :href="icon.url"
          class="cursor-pointer inline-flex gap-x-2 justify-end hover:border-primary-500 dark:hover:border-primary-200 border-b-4 border-transparent transition-colors text-sm font-bold text-primary-900 dark:text-primary-50"
          :title="icon.displayName"
          target="_blank"
        >
          <span class="hidden lg:inline-block">{{ icon.name }}</span>
          <UIcon
            class="fill-primary-900 dark:fill-primary-50 hidden lg:inline-block"
            :name="icon.iconClass ? icon.iconClass : ''"
            :size="18"
            mode="svg"
          />
          <UIcon
            class="fill-primary-900 dark:fill-primary-50 lg:hidden inline-block"
            :name="icon.iconClass ? icon.iconClass : ''"
            :size="36"
            mode="svg"
          />
        </a>
      </li>
    </ul>
  </address>
</template>
